<template>
  <div class="page-iOTDetails ">
    <Header  path='/productCenter'></Header>
    <div class="iOTDetails-banner"></div>
    <div class="iOTDetails-describe-1"></div>
    <div class="iOTDetails-describe-2"></div>
    <div class="iOTDetails-describe-3"></div>
    <Footer></Footer>
  </div>

</template>
<script>
  import Header from '@/components/Header/index.vue'
  import Footer from '@/components/Footer/index.vue'
  import router from '@/router'
  export default {
    components: {
      Header,
      Footer,
    },
    data() {
      return {

        
      }
    },

  }
</script>
<style lang="sass">
  @import "./style.scss"
</style>